import React, { useEffect, useRef } from "react";
import { smoothScroll } from "../../../common/helpers/helpers";

const ViewAllButton = () => {
  const viewAllRef = useRef(null);

  useEffect(() => {
    viewAllRef.current.focus();
  }, []);

  function scrollToTop() {
    smoothScroll(window.scrollY, 0, 600, -4, window.innerHeight * 0.7);
  }

  return (
    <button
      ref={viewAllRef}
      type="submit"
      tabIndex={0}
      onClick={scrollToTop}
      className="tw-px-4 tw-py-2 tw-text-sm tw-cursor-pointer tw-bg-transparent"
    >
      View All
    </button>
  );
};

export default ViewAllButton;
